<template>
  <label
    class="input-phone"
    :for="name"
  >
    <div
      v-if="name"
      class="input-phone__input-label"
      name="number or code"
    >{{ label }}</div>
    <div
      class="input-phone__input-and-lada"
      :class="inputClass"
    >
      <div
        class="input-phone__lada"
        name="lada"
      >
        <div class="input-phone__label">{{ lada }}</div>
      </div>
      <input
        v-if="onlyNumbers"
        :id="name"
        v-only-number
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :maxLength="maxLength"
        :value="value"
        :class="['input-phone__input', inputClass]"
        @input="$emit('input', $event.target.value)"
        @keydown.enter="(e) => { e.preventDefault(); $emit('enter', e); }"
        @focus="onFocus"
      />
      <input
        v-else
        :id="name"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :maxLength="maxLength"
        :value="value"
        :class="['input-phone__input', inputClass]"
        @input="$emit('input', $event.target.value)"
        @keydown.enter="(e) => { e.preventDefault(); $emit('enter', e); }"
        @focus="onFocus"
      />
      <button
        v-show="value"
        aria-label="Close alert"
        type="button"
        class="input-phone__reset-button"
        name="deletenumber"
        @click="$emit('input', '')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </label>
</template>

<script>
export default {
  name: 'InputPhone',
  props: {
    type: { type: String, default: 'text' },
    lada: { type: String, required: true },
    name: { type: String, required: true },
    label: { type: String, default: '' },
    value: { type: String, required: true },
    placeholder: { type: String, default: '' },
    pattern: { type: String, default: '' },
    onlyNumbers: { type: Boolean, default: false },
    maxLength: { type: Number, default: 8 },
    color: { type: String, default: 'red' },
    inputClass: { type: String, default: '' }
  },
  methods: {
    onFocus(event) {
      this.$emit('focus', event);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-phone {
  width: 100%;
  display: grid;
  font-size: 1.5625rem;
  flex-wrap: nowrap;
  position: relative;
  text-align: center;

  &__input-label {
    width: 100%;
    margin: 0;
    color: #dc3545;
    font-size: 1rem;
  }

  &__label {
    margin: 0;
    font-size: 1em;
  }

  &__reset-button {
    background: transparent;
    border: 0;
    text-decoration: none;
    background: transparent;
    cursor: pointer;
    text-align: center;
    position: absolute;
    font-size: 1.375em;
    right: 10px;
    padding: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
  }

  &__input-and-lada {
    display: flex;
    align-items: center;
    justify-items: center;
    height: 52px;
  }

  &__lada {
    display: flex;
    align-items: center;
    text-align: center;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    color: get-color('clear');
    padding: 6px 12px;
    line-height: 1.5;
    height: 100%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background: $mediumGray;
  }

  &__input {
    height: 100%;
    width: 100%;
  }
}
</style>
